import { render, staticRenderFns } from "./heartlist.vue?vue&type=template&id=4fbaa534&scoped=true"
import script from "./heartlist.vue?vue&type=script&lang=js"
export * from "./heartlist.vue?vue&type=script&lang=js"
import style0 from "./heartlist.vue?vue&type=style&index=0&id=4fbaa534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbaa534",
  null
  
)

export default component.exports